import { useTranslation } from "react-i18next";
import IconEdit from "../../../../layout/others/icon_edit.svg";
import "../styleDocuments.scss";
import Download from "../../../../components/Files/downloadDocuments";
import moment from "moment";
import { InterviewService } from "../../../../services/InterviewService";
import { toast } from "react-toastify";
import FileService from "../../../../services/FileService";
import DeleteDocument from "../DeleteDocument";
import { DOCOnlineService } from "../../../../services/DOCOnlineService";
import { useState, useEffect } from "react";
import { showError } from "../../../../services/ModalService";
import { useGeneralContext } from "../../../General/Context";
import ModalContainer from "../../../../containers/Modal/ModalContainer";

export function DocOnlineDocumentLine({
  docsOnline,
  setDocsOnline,
  setDocOnlineDownloadStatus,
  docOnlineDownloadStatus,
  disabled,
  deleteCallBack,
  interview
}) {
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();
  const { personalInformation, docOnlineLanguageInitials } = interview || {};
  const { fullName } = personalInformation || {};
  const [haswebView, setHasWebView] = useState(false);
  const [docOnlineData, setDocOnlineData] = useState(null);
  const [validationErrors, setValidationErrors] = useState([]);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null); 

  useEffect(() => {
    DOCOnlineService.hasWebView().then((data) => setHasWebView(data.webView));
  }, []);
  
  function openDOCOnlineEdit(docOnlineId) {
    window.open(`/interviews/DOCEdit/${docOnlineId}`);
  }
  
  function generateUrl(file) {
    if (file.url) {
      try {
        navigator.clipboard.writeText(file.url);
        toast.success("copied");
      } catch (error) {
        showError(t("Your browser does not support clipboard"));
      }

      setTimeout(() => window.open(file.url), 2000);
    } else
      DOCOnlineService.generateUrl(
        file.langCode,
        userInformation.companyId,
        file.id
      ).then((data) => {
        let _docsOnline = [...docsOnline];
        _docsOnline.forEach((f) => {
          if (f.id === file.id) {
            f.url = data.url;
          }
        });
        navigator.clipboard.writeText(data.url);
        setDocsOnline(_docsOnline);
        setTimeout(() => window.open(file.url), 2000);
      });
  }

  const downloadDocOnlineTemplate = (file) => {
    setDocOnlineDownloadStatus({ statusName: "downloading" });
    if (docOnlineDownloadStatus.statusName === "done") {
      InterviewService.DownloadDocOnline(
        file.id,

        file.generatedLanguageId,
        `DOCOnline_${fullName.replace(
          " ",
          ""
        )}_${docOnlineLanguageInitials}_${moment().unix()}`,
        true
      )
        .then(() =>
          setDocOnlineDownloadStatus({
            errorCaught: false,
            statusName: "downloaded"
          })
        )
        .catch((err) => {
          setDocOnlineDownloadStatus((prevState) => ({
            ...prevState,
            errorCaught: true
          }));
          console.error(err);
          toast.error(t("Something went wrong."));
        })
        .finally(() => {
          setTimeout(
            () =>
              setDocOnlineDownloadStatus((prevState) => ({
                ...prevState,
                statusName: "done"
              })),
            3000
          );
        });
    } else {
      toast.warn(t("Wait until the first requested download is complete."));
    }
  };

  function downloadOreditDocOnline(file) {
    DOCOnlineService.getDocOnlineById(file.id)
      .then((data) => {
        setDocOnlineData(data);
        const errors = validateDocOnline(data);
        if (errors.length > 0) {
          setValidationErrors(errors);
          setShowValidationModal(true);
          setSelectedFileId(file.id);
          return;
        }

        if (haswebView && file.storedFileName == null) {
          generateUrl(file);
        }
        else {
          if (file.storedFileName == null) {
            downloadDocOnlineTemplate(file);
          }else {
            FileService.DownloadFileBase64(`vitae/file/${file.id}`, true);
          }
        }
      })
      .catch((err) => {
        console.error("Erro ao carregar DOC Online:", err);
      });
  }

  function validateDocOnline(doc) {
    const errors = [];

    if (!doc?.personalInformation?.fullName) {
      errors.push(t("Full Name is required"));
    }

    if (!isValidDate(doc?.personalInformation?.birthDate)) {
      errors.push(t("Birth Date is required"));
    }

    if (!doc?.personalInformation?.jobRoleId) {
      errors.push(t("Job Role is required"));
    }

    if (!doc?.personalInformation?.yearsOfExperience) {
      errors.push(t("Years of Experience is required"));
    }

    if (!doc?.personalInformation?.resume || doc.personalInformation.resume.length < 30) {
      errors.push(t("Resume must be at least 30 characters"));
    }

    if(!doc?.motherLanguageId){
      errors.push(t("Mother Language is required"));
    }

    if (validateLanguages(doc?.docLanguages)) {
      errors.push(t("Language level is required for all selected languages"));
    }
    
    if (validateWorkExperiences(doc?.docWorkExperiences)) {
      errors.push(t("All work experience fields are required"));
    }

    if (validateSkills(doc?.competences)) {
      errors.push(t("Experience time and level are required for all skills"));
    }

    if (validateSkills(doc?.otherCompetences)) {
      errors.push(t("Experience time and level are required for all other skills"));
    }

     return errors; 
  }

  function isValidDate(dateStr) {
    if (!dateStr) {
      return false;
    }

    const invalidDate = "0001-01-01T00:00:00";
    if(dateStr === invalidDate){
      return false;
    }
    return moment(dateStr, moment.ISO_8601, true).isValid();
  }

  function validateLanguages(docLanguages = []) {
    return docLanguages.some(
      lang => lang.languageId && !lang.languageLevelId
    );
  }

  function validateWorkExperiences(workExperiences = []) {
    return workExperiences.some(exp =>
      !exp.companyOrEmployName ||
      !exp.startDate ||
      !exp.occupationOrPositionHeld ||
      (!exp.endDate && !exp.projectStillGoing)
    );
  }

  function validateSkills(skills = []) {
    return skills.some(skill =>
      skill.skillId &&
      (
        !skill.skillExperienceTimeId ||
        !skill.skillLevelId ||
        !skill.description
      )
    );
  }

  return (
    <>
      {docsOnline &&
        interview &&
        docsOnline.map((file) => (
          <tr
            key={file.id}
            title={
              file.storedFileName ?? t("Open DocOnline within the template")
            }
            onClick={() => downloadOreditDocOnline(file)}
          >
            <td className="languages">{file.language}</td>
            <td className="description">{file.description}</td>
            <td className="updated-date">
              {moment(file.updateAt).format("DD-MM-YYYY")}
            </td>
            <td>{file.modifiedBy}</td>
            <td className="actions d-flex">
              {file.storedFileName === null ? (
                <button
                  type="button"
                  title={t("Edit DocOnline")}
                  onClick={(e) => {
                    e.stopPropagation();
                    openDOCOnlineEdit(file.id);
                  }}
                  className="action-button"
                >
                  <img src={IconEdit} alt="edit" width="17px" height="22px" />
                </button>
              ) : (
                !disabled && (
                  <>
                    <Download
                      url={`vitae/file/${file.id}`}
                      fileName={file.description}
                    />
                    <DeleteDocument
                      documentId={file.id}
                      interviewId={interview.interviewId}
                      deleteCallBack={deleteCallBack}
                    />
                  </>
                )
              )}
              {haswebView && file.storedFileName == null && (
                <button
                  title={t("View&Copy")}
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadOreditDocOnline(file);
                  }}
                  className="action-button"
                >
                  <i className="bi bi-eye bold"></i>
                </button>
              )}
            </td>
          </tr>
        ))}
      {(!docsOnline || (docsOnline && docsOnline.length === 0)) && (
        <tr>
          <td colSpan="4" className="text-center">
            {t("No files added")}
          </td>
        </tr>
      )}
      {showValidationModal && (
        <ModalContainer
          modalTitle={t("DocOnline Missing Fields")}
          isOpen={showValidationModal}
          closeModal={() => setShowValidationModal(false)}
          cancelButtonTitle={t("Close")}
          cancelButtonAction={() => setShowValidationModal(false)}
          submitButtonTitle={t("Edit DocOnline")}
          submitButtonAction={() => openDOCOnlineEdit(selectedFileId)}
        >
          <span style={{marginBottom:"10px !important"}}>{t("The following fields must be completed in DocOnline before downloading")}</span>
          <p></p>
          <ul>
            {validationErrors.map((err, idx) => (
              <li key={idx}>{err}</li>
            ))}
          </ul>
        </ModalContainer>
      )}
    </>
  );
}
